import { Link, useLocation } from 'react-router-dom';

const ITEMS = [
  { key: 'hero', to: '/', icon: 'home', label: 'Beranda' },
  { key: 'layanan', to: '/layanan', icon: 'auto_awesome', label: 'Layanan' },
  { key: 'portofolio', to: '/portofolio', icon: 'grid_view', label: 'Portofolio' },
  { key: 'testimoni', to: '/testimoni', icon: 'format_quote', label: 'Testimoni' },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  const kontakActive = pathname.startsWith('/kontak');

  // Bottom nav mobile disembunyikan total di halaman artikel (navbar atas berubah jadi mode "artikel")
  if (pathname.startsWith('/artikel/')) return null;

  return (
    <div className="nav-desktop:hidden fixed bottom-4 left-4 right-4 z-50 flex items-center gap-3 landscape:justify-between">
      <nav className="flex-1 landscape:flex-none flex items-center justify-around landscape:justify-start landscape:gap-1 px-2 py-2 rounded-full bg-white/90 dark:bg-neutral-900/90 backdrop-blur-md border border-white/50 dark:border-neutral-700/60 shadow-[0_8px_32px_rgba(0,0,0,0.12),0_2px_8px_rgba(0,0,0,0.08)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.55)] transition-all duration-300 ease-[cubic-bezier(0.2,0.8,0.2,1)]">
        {ITEMS.map((item) => {
          const active = pathname === item.to;
          return (
            <Link key={item.key} to={item.to} className={`bn-item ${active ? 'bn-active' : ''}`}>
              <span className="bn-pill">
                <span className="bn-icon material-symbols-outlined">{item.icon}</span>
                <span className="bn-label">{item.label}</span>
              </span>
            </Link>
          );
        })}
      </nav>

      <Link
        to="/kontak"
        className={`bn-cta flex-shrink-0 flex items-center justify-center w-16 h-16 rounded-2xl bg-[var(--accent)] dark:bg-[var(--accent-hover)] text-white shadow-[0_8px_24px_color-mix(in_oklab,_var(--accent)_45%,_transparent)] hover:bg-[var(--accent-hover)] dark:hover:bg-[var(--accent)] hover:shadow-[0_10px_30px_color-mix(in_oklab,_var(--accent)_60%,_transparent)] ${kontakActive ? 'bn-active' : ''}`}
        title="Buat Janji"
      >
        <span className="bn-cta-icon material-symbols-outlined text-2xl leading-none">edit_calendar</span>
      </Link>
    </div>
  );
}
